export default function Views_convertStatusStringToStatuses(status: 'open' | 'closed' | 'all') {
    // transform 'open' 'closed' 'all' to array
    let systemStatuses = []
    switch (status) {
        case 'open'     : systemStatuses = gd.const.systemStatus.OPEN_STATUSES; break
        case 'closed'   : systemStatuses = gd.const.systemStatus.CLOSED_STATUSES; break
        case 'all'      :
        default         : systemStatuses = gd.const.systemStatus.ALL_STATUSES; break
    }

    return systemStatuses
}